import React from 'react';
import { XOutlined } from '@ant-design/icons';
import { useTranslation } from 'react-i18next';

interface HeaderSectionProps {
  onNavigate: (section: 'twitter' | 'tiktok' | 'instagram') => void;
  activeSection: 'twitter' | 'tiktok' | 'instagram';
}

const HeaderSection: React.FC<HeaderSectionProps> = ({ onNavigate, activeSection }) => {
  const { t } = useTranslation('common');
  const handleNavigate = (section: 'twitter' | 'tiktok' | 'instagram') => {
    onNavigate(section);
  };

  return (
    <div className="max-w-[1200px] mx-auto mt-20 lg:mt-0 px-2 lg:px-0">
      <h1 className="lg:text-5xl text-4xl font-bold text-[#333333] mb-5 lg:leading-[1.3] mt-12  lg:mt-0 text-center lg:max-w-[800px] w-[full] mx-auto">
        {t('Trusted by real Instagram Users Who Love to Know 👀')}
      </h1>

      <div
        className="text-[#0C0C0C] text-center max-w-[900px] mx-auto mb-10"
        dangerouslySetInnerHTML={{
          __html: t(
            "Over a million of us already use Dolphin Radar to see what really happens on Instagram.Here's what people are saying on X, TikTok, and Instagram. Share yours with <span style='font-weight: bold;'>#DolphinRadar</span>."
          ),
        }}
      ></div>
      <div className="flex z-[100] lg:justify-center lg:relative fixed top-[64px] lg:top-0 left-0 lg:w-fit w-[100vw] lg:mx-auto">
        <div className="inline-flex lg:rounded-lg border border-[#e0e0e0] divide-x divide-[#e0e0e0] bg-white min-w-max w-full">
          <button
            className={`lg:w-[160px] flex-1 h-[40px] flex justify-center items-center gap-1 bg-[#ECEDF4] hover:bg-[#725CFF]/10 hover:text-[#725CFF]`}
            onClick={() => handleNavigate('twitter')}
          >
            <XOutlined className="text-base" />
            <span>Twitter</span>
          </button>

          <button
            className={`lg:w-[160px] flex-1 h-[40px] flex justify-center items-center gap-1 bg-[#ECEDF4] hover:bg-[#725CFF]/10 hover:text-[#725CFF]`}
            onClick={() => handleNavigate('tiktok')}
          >
            <img src="/images/testimonials/tiktoktag.svg" alt="TikTok" width={16} height={16} />
            <span>TikTok</span>
          </button>

          <button
            className={`lg:w-[160px] flex-1 h-[40px] flex justify-center items-center gap-1 bg-[#ECEDF4] hover:bg-[#725CFF]/10 hover:text-[#725CFF]`}
            onClick={() => handleNavigate('instagram')}
          >
            <img src="/images/testimonials/instagramtag.svg" alt="Instagram" width={16} height={16} />
            <span>Instagram</span>
          </button>
        </div>
      </div>
    </div>
  );
};

export default HeaderSection;
